import proxy from "./Proxy";
import CardReader from "./CardReader";
export default function Main() {
    function CardReaders() {
        return new CardReader();
    }
    function Connects(name, data) {
        if (name === "CardReader") {
            CardReaders().Connect(data);
        }
    }
    function DisConnects(list_id) {
        CardReaders().DisConnect(list_id.CardReader);
    }
    if (window.$Core.App.IsNative) {
        Object.defineProperties(this, {
            Connects: proxy.ForGet(Connects, this),
            DisConnects: proxy.ForGet(DisConnects, this),
            CardReaders: proxy.ForGet(CardReaders, this),
        });
    }
}
